import { render, staticRenderFns } from "./rules.middle.vue?vue&type=template&id=1ac2fe46&scoped=true"
import script from "./rules.middle.vue?vue&type=script&lang=js"
export * from "./rules.middle.vue?vue&type=script&lang=js"
import style0 from "./rules.middle.vue?vue&type=style&index=0&id=1ac2fe46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.nvm/versions/node/v22.19.0/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac2fe46",
  null
  
)

export default component.exports